import React from 'react';
// Components
import BrandsTable from 'components/common/BrandsTable/BrandsTable';

const Brands = (): JSX.Element => {
  return <BrandsTable />;
};

export default Brands;
